import { Box } from '@mui/material';

import type { ClusterPlacementSize } from './types';

export function ClusterPlacementPlaceholder({ size }: { size: ClusterPlacementSize }) {
  return (
    <Box
      className="card-placement-margin"
      sx={{
        bgcolor: 'rgba(0, 0, 0, 0.1)',
        flex: '0 0 auto',
        height: size.height,
        width: size.width,
      }}
    />
  );
}
